import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  Subject,
  debounceTime,
  distinctUntilChanged,
  startWith,
  takeUntil,
} from 'rxjs';
import {
  ClientsService,
  ListClientItem,
} from 'src/app/services/clients/clients.service';
import { ChipDropdownComponent } from '../../../../shared/payee-cases/chip-dropdown/chip-dropdown.component';
import { PayeeFormFieldComponent } from '../../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeAutocompleteComponent } from '../../../../shared/payee-form-fields/payee-autocomplete/payee-autocomplete.component';
import { PayeeButtonComponent } from '../../../../shared/payee-buttons/payee-button/payee-button.component';

@Component({
  selector: 'app-client-filter',
  templateUrl: './client-filter.component.html',
  styleUrls: ['./client-filter.component.scss'],
  imports: [
    ChipDropdownComponent,
    PayeeFormFieldComponent,
    PayeeAutocompleteComponent,
    FormsModule,
    ReactiveFormsModule,
    PayeeButtonComponent,
  ],
})
export class ClientFilterComponent implements OnInit, OnDestroy {
  private clientsService = inject(ClientsService);

  private readonly destroy = new Subject<void>();
  readonly setClients$ = new Subject<string>();
  readonly formControl = new FormControl<ListClientItem | null>(null);
  dropdownOpen = false;

  @Input() value: ListClientItem | null = null;
  @Output() valueChange = new EventEmitter<ListClientItem | null>();

  clientOptions: ListClientItem[] = [];

  ngOnInit(): void {
    this.setClients$
      .pipe(
        takeUntil(this.destroy),
        debounceTime(500),
        distinctUntilChanged(),
        startWith(''),
      )
      .subscribe(async (name) => {
        try {
          const result = await this.clientsService.listClients({ name });
          this.clientOptions = result.clients;
        } catch (error) {
          console.error('Error while getting client options', error);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  removed(): void {
    this.value = null;
    this.valueChange.emit(this.value);
    this.dropdownOpen = false;
    this.formControl.patchValue(null);
  }

  apply(): void {
    this.value = this.formControl.value;
    this.valueChange.emit(this.value);
    this.dropdownOpen = false;
  }

  displayClient(client?: ListClientItem): string {
    return client?.name || '';
  }
}
